import { useLayoutEffect, useState } from "react";
import { BrowserRouterProps, Router } from "react-router-dom";
import { BrowserHistory } from "history";
import apphistory from './common/AppHistory'


interface Props extends BrowserRouterProps {
  history: BrowserHistory;
}


/**
 * Customowy Router używany do Routingu w aplikacji. 
 * Wersja 6 biblioteki react-router-dom wymaga takiego podejścia, aby móc skorzystać
 * z biblioteki history, i móc używać nawigacji poza komponentami Reacta 
*/
const CustomRouter = ({ basename, history, children }: Props) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  })

  useLayoutEffect(() => history.listen(setState), [history])

  return (
    <Router
      navigator={apphistory}
      location={state.location}
      navigationType={state.action}
      children={children}
      basename={basename}
    />
  )
}


export default CustomRouter